import { format } from "date-fns";
import { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { Toaster } from "react-hot-toast";
import { TpnRoutes } from "../../data";
import { useTpnSummaryQuery } from "../../services/tpnApi";
import WareHouseDW from "../Common/CustomSelect/WareHouseDW";
import Header from "../Common/Header/Header";
import LoadingModal from "../Common/Modal/LoadingModal";
import ExportNav from "../Common/Nav/ExportNav";
import SideBar from "../Common/SideBar/SideBar";
import { signInUser } from "../Utility/Auth";

function TPNSummary() {
  // Date
  const [startDate, setStartDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const [endDate, setEndDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const [exportData, setExportData] = useState([]);
  const [warehouse, setWarehouse] = useState("allWh");
  const [aamarId, setAamarId] = useState("");
  const [loader, setLoader] = useState(true);
  const auth = signInUser();
  const { storeSettings } = auth;
  const { data, isSuccess, refetch } = useTpnSummaryQuery({
    startDate,
    endDate,
    warehouse,
    aamarId,
  });

  useEffect(() => {
    refetch();
  }, [startDate, endDate, warehouse, aamarId]);

  useEffect(() => {
    if (auth?.type === "admin") {
      setWarehouse("allWh");
    } else {
      setWarehouse(auth?.warehouse);
    }
  }, []);
  useEffect(() => {
    setAamarId(auth?.aamarId);
  }, []);

  console.log("warehouse", warehouse);

  useEffect(() => {
    setLoader(false);
    let newData = [];
    if (data?.products?.length > 0) {
      setExportData([]);

      data?.products?.map((pro) => {
        newData = [
          ...newData,
          {
            ...pro,
            mrp: pro.mrp / pro.tpnQty,
            tp: pro.tp / pro.tpnQty,
            vat: pro.vat / pro.tpnQty,
          },
        ];
        // console.log(pro.mrp, pro.mrp / pro.rtvQty);
      });
      setExportData(newData);
    }
  }, [isSuccess, data]);

  // console.log(data, exportData);

  const handleLoaderClose = () => setLoader(false);

  const handleOnchangeWareHouseFrom = (e) => {
    if (e.option !== "no-warehouse") {
      setWarehouse(e.option);
    } else {
      setWarehouse("allWh");
    }
  };

  const preHeader = [
    [`${storeSettings?.storeName || "No-Name"}`],
    [`${storeSettings?.address?.street || "No-Street"}`],
    [
      `${storeSettings?.address?.city || "No-City"}-${
        storeSettings?.address?.post || "No-PostalCode"
      }`,
    ],
    [
      `For the Period: ${format(new Date(startDate), "MM-dd-yyyy")} to ${format(
        new Date(endDate),
        "MM-dd-yyyy"
      )}`,
    ],
    ["RTV Summary Report"],

    [], // Empty row for spacing
  ];
  return (
    <div>
      <div className="container-fluid ">
        <LoadingModal
          title={"Please Wait"}
          onShow={loader}
          handleClose={handleLoaderClose}
        ></LoadingModal>
        <div className="row">
          <div className="col-md-2">
            <SideBar></SideBar>
          </div>
          <div className="col-md-10">
            <Header title="Tpn Summary by Article"></Header>
            <div className="row mt-3">
              <div className="col-md-6">
                {/* Sort date range */}
                <div className="date-picker d-flex mb-2 align-items-center gap-2">
                  {/* <b>Start:</b> */}
                  <DatePicker
                    selected={new Date(startDate)}
                    className="form-control me-2"
                    onChange={(date) =>
                      setStartDate(format(new Date(date), "MM-dd-yyyy"))
                    }
                  />
                  <span width="10px"></span>
                  {/* <b>End:</b> */}
                  <DatePicker
                    selected={new Date(endDate)}
                    className="form-control"
                    onChange={(date) =>
                      setEndDate(format(new Date(date), "MM-dd-yyyy"))
                    }
                  />
                  {/* warehouse */}
                  {auth?.type === "admin" && (
                    <div style={{ width: "40%" }}>
                      <WareHouseDW
                        id="warehouse"
                        name="warehouse"
                        handleOnChange={handleOnchangeWareHouseFrom}
                        className="form-control"
                        // Consistent width for custom components
                      />
                    </div>
                  )}
                  {/* Search */}
                  {/* <input
                    className="form-control"
                    name="search"
                    type="Search"
                    onChange={(e) => setSearch(e.target.value)}
                  />*/}
                </div>
              </div>
              <div className="col-md-6">
                <span className="float-end">
                  <ExportNav
                    preheader={preHeader}
                    Routes={TpnRoutes}
                    data={exportData}
                    title="RTV Summary"
                  />
                </span>
              </div>
            </div>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th className="">Aricle Code</th>
                  <th>Name</th>
                  {/* <th className="text-end">Avg MRP</th> */}
                  <th className="text-end">Avg TP</th>
                  <th className="ps-3">QTY</th>
                  <th className="text-center">Unit</th>
                  <th className="text-center">TPN</th>
                  <th className="text-end">Total Value</th>
                </tr>
              </thead>
              <tbody>
                {data?.products?.length > 0 ? (
                  data?.products?.map((tpn) => (
                    <tr key={tpn._id}>
                      {/* <td>{tpn.tpnNo}</td> */}
                      <td className="">{tpn.article_code}</td>
                      <td>{tpn.name}</td>
                      {/* <td className="text-end">
                        {(tpn.mrp / tpn.tpnQty).toFixed(2)}
                      </td> */}
                      <td className="text-end">
                        {(tpn.tp / tpn.tpnQty).toFixed(2)}
                      </td>
                      <td className="ps-3">
                        <b>{parseFloat(tpn.qty)} </b>
                      </td>
                      <td className="text-center">{tpn.unit}</td>
                      <td className="text-center">{tpn.tpnQty}</td>
                      <td className="text-end">
                        <b>{new Intl.NumberFormat().format(tpn.stockValue)} </b>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr colSpan={7}>No Product Found</tr>
                )}
                <tr>
                  <td className="text-end" colSpan={6}>
                    <b>TOTAL VALUE:</b>
                  </td>
                  <td className="text-end">
                    <b>
                      {typeof data?.stockValue === "number"
                        ? new Intl.NumberFormat().format(data?.stockValue)
                        : 0}
                    </b>
                  </td>
                </tr>
              </tbody>
            </Table>
            {/* pagination */}
            {/* <ProductDataTable></ProductDataTable> */}
          </div>
        </div>
      </div>

      <Toaster position="bottom-right" />
    </div>
  );
}

export default TPNSummary;
